import React from 'react';
import { PaymentMethodsTypes, PaymentStatusTypes } from '@/hooks/billing/subscriptions/usePaymentModal/usePaymentModal.types';
import { Button } from 'gatorcomponents';

export default {
  title: 'Pagar fatura',
  titleSubscriptions: 'Alterar forma de pagamento',
  descriptionSubscriptions: 'Escolha o método de pagamento para renovar suas próximas faturas ou ajuste as parcelas:',
  invoiceDetails: {
    invoice: 'Fatura',
    dueDate: 'Vencimento',
    subtotal: 'Subtotal',
    totalValue: 'Valor total + impostos',
    total: 'Total',
    taxes: 'Impostos',
    credits: 'Créditos',
    amountPaid: 'Já foi pago',
    showDetailsButtonLabel: 'Ver detalhes',
    hideDetailsButtonLabel: 'Ocultar detalhes',
    vatTooltip: taxRate => `O VAT (Value-Added Tax) é aplicado de acordo com a legislação tributária do país. A alíquota atual é de ${taxRate}%.`,
  },
  successChangeMethodToast: {
    title: 'Pagamento atualizado',
    info: 'Suas próximas faturas usarão a nova forma de pagamento.',
  },
  invoiceDetailsLabel: 'Detalhes da fatura',
  selectPaymentMethod: 'Selecione a forma de pagamento',
  installmentLabel: (installment, value) => `${installment}x de ${value}`,
  paymentMethods: {
    [PaymentMethodsTypes.BANK_TRANSFER]: {
      name: 'Transferência bancária',
      selectPlaceholder: 'Selecione a opção de pagamento',
      icon: 'IconSwitch',
    },
    [PaymentMethodsTypes.GP_BOLETO]: {
      name: 'Boleto bancário',
      icon: 'IconData',
      description: () => (
        <>
          Pagamentos via boleto podem levar até 24h para serem identificados.
          <div>
            Para acesso imediato, prefira
            {' '}
            <b>Cartão de Crédito, Pix ou PayPal.</b>
          </div>
        </>
      ),
      getTicketButton: 'Gerar boleto',
      modalTitle: 'Pagar com Boleto bancário',
      changeMethodButtonLabel: 'Alterar forma de pagamento',
      instruction: 'Para pagar seu boleto, basta utilizar as informações abaixo:',
      ticketTipLabels: {
        0: 'Você pode pagar seu boleto em qualquer lotérica, caixa eletrônico ou aplicativo de banco.',
        1: 'O seu pagamento será processado e confirmado em até 24h úteis. Portanto, após o pagamento aguarde a compensação para evitar duplicidade.',
        2: 'Se o vencimento do seu boleto cair em um feriado ou final de semana, você poderá pagá-lo no próximo dia útil.',
      },
      saveTicketButton: 'Salvar boleto em PDF',
      printTicketButton: 'Imprimir boleto',
    },
    [PaymentMethodsTypes.GP_PAYPAL]: {
      name: 'PayPal',
      icon: 'IconPayPal',
      directions: 'Clique no botão acima para confirmar e realizar seu pagamento no PayPal.',
      selectAccount: 'Selecione qual conta PayPal gostaria de utilizar:',
      alert: 'Transação segura e criptografada.',
    },
    [PaymentMethodsTypes.EFECTIVE_PAYMENT]: {
      name: 'Pago en Efectivo',
      icon: 'IconData',
      selectPlaceholder: 'Selecciona la opción de pago',
      buttonLabel: 'Continuar para o pagamento',
      description: 'Você será redirecionado para concluir seu pagamento em uma tela segura.',
      modal: {
        title: 'Siga as instruções da plataforma de pagamento',
        description: 'Uma nova página foi aberta para que você realize seu pagamento. Siga as instruções e acompanhe o status do seu pagamento em sua lista de faturas.',
        buttonLabel: 'Fechar',
        redirectText: 'Caso a página não abra automaticamente, clique aqui',
      },
    },
    [PaymentMethodsTypes.PAYU_BOLETO]: {
      name: 'Pago en Efectivo',
      icon: 'IconData',
      selectPlaceholder: 'Selecciona la opción de pago',
      buttonLabel: 'Continuar para o pagamento',
      description: 'Você será redirecionado para concluir seu pagamento em uma tela segura.',
      modal: {
        title: 'Siga as instruções da plataforma de pagamento',
        description: 'Uma nova página foi aberta para que você realize seu pagamento. Siga as instruções e acompanhe o status do seu pagamento em sua lista de faturas.',
        buttonLabel: 'Fechar',
        redirectText: 'Caso a página não abra automaticamente, clique aqui',
      },
    },
    [PaymentMethodsTypes.BRASPAG_CREDIT]: {
      name: 'Novo Cartão de crédito',
      icon: 'IconCard',
      replaceCardLabel: 'Substituirá o cartão acima em todas as assinaturas vinculadas à ele.',
      useOnNextRenovationLabel: 'Usar esta forma de pagamento nas próximas renovações deste(s) produto(s).',
      saveCcButtonLabel: 'Pagar fatura e Salvar Cartão',
      changeMethodButtonLabel: 'Alterar e Salvar Cartão',
      bottomMessage: 'Transação segura e criptografada.',
      selectInstallmentsPlaceholder: 'Selecione o número de parcelas',
    },
    [PaymentMethodsTypes.DLOCAL]: {
      name: '',
      icon: '',
      replaceCardLabel: '',
      useOnNextRenovationLabel: '',
      saveCcButtonLabel: '',
      bottomMessage: '',
      selectInstallmentsPlaceholder: '',
    },
    [PaymentMethodsTypes.CURRENT_CREDIT_CARD]: {
      name: 'Cartão cadastrado',
      selectInstallmentsPlaceholder: 'Selecione o número de parcelas',
      useOnNextRenovationLabel: 'Usar esta forma de pagamento nas próximas renovações deste(s) produto(s).',
      dueLabel: date => `Vence em ${date}`,
      payInvoiceButtonLabel: 'Pagar fatura',
      changeMethodButtonLabel: 'Alterar forma de pagamento',
      bottomMessage: 'Transação segura e criptografada.',
    },
    [PaymentMethodsTypes.QR_PAYMENT]: {
      name: 'Pagar com QR Code',
      icon: 'IconQrCode',
    },
    [PaymentMethodsTypes.WALLET]: {
      name: 'Billetera Eletcrónica',
      icon: 'IconQrCode',
    },
    [PaymentMethodsTypes.PIX]: {
      name: 'Pix',
      icon: 'IconPix',
      label: 'Gerar código Pix',
      labelChangePaymentMethod: 'Alterar forma de pagamento',
      description: "Clique no botão 'Gerar código Pix' para confirmar e realizar seu pagamento na próxima tela.",
      descriptionChangePaymentMethod: "Clique no botão 'Alterar forma de pagamento' para confirmar e realizar seu pagamento na próxima tela.",
      secureTransition: 'Transação rápida e segura com o Pix.',
    },
    modo: {
      icon: 'IconModo',
    },
    yape: {
      icon: 'IconYape',
    },
    defaultContinue: 'Continuar para o pagamento',
    defaultContinueChangeMethod: 'Alterar forma de pagamento',
    defaultDescription: 'Você será redirecionado para concluir seu pagamento em uma tela segura.',
    multiplePaymentMethodsDescription: 'Você será redirecionado para concluir seu pagamento em uma tela segura.',
  },
  paymentStatus: {
    [PaymentStatusTypes.SUCCESS_GENERIC]: {
      title: 'Pagamento concluído',
      description: 'Parabéns! Seu pagamento foi realizado com sucesso. Em breve, você receberá um e-mail de confirmação.',
      buttonLabel: 'Voltar para minhas faturas',
    },
    [PaymentStatusTypes.FAILURE_CREDIT_CARD]: {
      title: 'Ops! Algo deu errado no seu pagamento',
      description: 'Tente novamente em alguns minutos ou utilize outro Cartão de Crédito.',
      buttonLabel: 'Tentar novamente',
      secondButtonLabel: 'Usar outro Cartão',
    },
    [PaymentStatusTypes.PIX_TIME_EXPIRED]: {
      title: 'Tempo para pagamento esgotado',
      description: 'Altere o método de pagamento ou atualize o QR Code para concluir. Se já realizou o pagamento, você receberá um e-mail de confirmação em breve.',
      buttonLabel: 'Alterar forma de pagamento',
      secondButtonLabel: 'Atualizar QR Code',
    },
    [PaymentStatusTypes.FOLLOW_NEW_TAB_INSTRUCTIONS]: {
      title: 'Siga as instruções da plataforma de pagamento',
      description: 'Uma nova página foi aberta para que você realize seu pagamento. Siga as instruções e acompanhe o status do seu pagamento em sua lista de faturas.',
      buttonLabel: 'Fechar',
      pageNotLoaded: ({ handleClick }) => (
        <>
          {'Caso a página não abra automaticamente, '}
          <Button
            variant="text"
            onClick={handleClick}
            label="clique aqui"
          />
        </>
      ),
    },
    [PaymentStatusTypes.PIX_ONGOING]: {
      modalTitle: 'Pagar com Pix',
      contentTitle: 'Copie o código abaixo ou escaneie o QR Code para efetuar o pagamento.',
      copyTimerText: 'Tempo restante para pagamento:',
      list: [
        'No App do seu banco, selecione a opção que deseja: Pagar QR Code ou Pix Copia e Cola;',
        'Após o pagamento, aguarde a confirmação na tela;',
        'Pronto, o pagamento foi feito com sucesso!',
      ],
    },
    [PaymentStatusTypes.GENERIC_FAILURE]: {
      title: 'Algo deu errado na sua solicitação',
      description: 'Tente novamente ou utilize outro método de pagamento.',
      tryAgain: 'Tentar novamente',
      anotherMethod: 'Usar outro método de pagamento',
    },
    [PaymentStatusTypes.PENDING_ANALYSIS]: {
      title: 'Pedido em análise',
      description: email => (
        <>
          {'O prazo de análise do seu pedido é de 24 a 48 horas úteis. Quando o pedido for aprovado, você receberá um e-mail em '}
          <strong>{email}</strong>
        </>
      ),
      buttonLabel: 'Fechar',
    },
  },
};
